// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pm-template-list-item[data-v-e6e4a744] {\n  display: flex;\n  gap: 10px;\n}\n.pm-template-list-item .index[data-v-e6e4a744] {\n  flex: 1;\n}\n.box-bubble[data-v-e6e4a744] {\n  border: 1px solid #cfcdcd;\n  padding: 10px;\n  border-radius: 10px;\n}", ""]);
// Exports
module.exports = exports;
